/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';

const messages = defineMessages({
    pageTitle: {
        id: 'portal.notAuthorizedPage.pageTitle',
        defaultMessage: 'Not Authorized!'
    },
    pageHeader: {
        id: 'portal.notAuthorizedPage.pageHeader',
        defaultMessage: "We're sorry! The page you are looking for can not be accessed."
    }
});

const { styleComponent } = getStylist('NotFoundPage');
const CenteredText = styleComponent<LuisTextProps>(LuisText)('CenteredText', theme => ({
    textAlign: 'center',
    marginBottom: theme.textMargin
}));

/**
 * Renders a simple not authorized page.
 */
export const NotAuthorizedPage = () => {
    const { localize } = useLocalization();

    return (
        <Page pageName="NotAuthorizedPage" size="container" title={localize(messages.pageTitle)}>
            <CenteredText variant="mega" as="h1">
                401
            </CenteredText>

            <CenteredText variant="xxLargePlus" as="h2">
                {localize(messages.pageHeader)}
            </CenteredText>
        </Page>
    );
};
